import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject, take } from 'rxjs';

import { AuthenticationBackendService } from '../services/authentication-backend.service';
import { TextNotificationService } from '../../common-app/services/text-notification.service';
import { LoginData } from '../model/login-data';
import { ErrorService } from '../../common-app/services/error.service';
import { SECURITY_MODULE_CONFIG, SecurityModuleConfig } from '../security-config';
import { EnviromentContextService } from '../../enviroment/services/enviroment-context-service';

type PasswordFormType = { userId: FormControl<string>, password: FormControl<string> };

@Component({
  templateUrl: './login-backend.component.html',
  styleUrls: ['./login-backend.component.scss']
})
export class LoginBackendComponent implements OnInit {

  
  protected form: FormGroup<PasswordFormType>;
  protected progres$ = new Subject<void>();

  constructor(
    @Inject(SECURITY_MODULE_CONFIG) private config: SecurityModuleConfig,
    private fb: FormBuilder,
    private authenticationService: AuthenticationBackendService,
    private textNotificationService: TextNotificationService,
    private errorService: ErrorService,
    private environmentContextService: EnviromentContextService,
    private router: Router) {
    this.form = this.fb.nonNullable.group<PasswordFormType>({
      userId: new FormControl<string>('',  {nonNullable: true, validators: [Validators.required]}),
      password: new FormControl<string>('',  {nonNullable: true}),
    });
  }

  ngOnInit(): void {
  }

  onSubmit() {
    const data: LoginData = {
      password: this.form.value.password as string,
      userId: this.form.value.userId as string
    };
    this.authenticationService.login(data).pipe(
      take(1)
    ).subscribe(
      {
        next: (data) => {
          this.environmentContextService.setDiffVersion(data.returnsNR);
          this.textNotificationService.text("Login success");
          this.router.navigate([this.config.postLoginBackendUrl]);
          this.progres$.next();
        },
        error: (error) => {
          if (error.status !== undefined && error.status === 401) {
            this.textNotificationService.error('Login failed');
          } else {
            this.textNotificationService.error(this.errorService.friendlyError(error, error.message));
          }
          this.progres$.next();
        }
      }
    )
  }

}
